export class ServiceContractSlot
{
    name1        : string;
    name2        : string;
    name3        : string;
    name4        : string;
    name5        : string;
    name6        : string;

    booking      : number = 0
    // ticketPrefix1: string;
    // bookPrefix1  : string;
    // ticketPrefix2: string;
    // bookPrefix2  : string;
    // ticketPrefix3: string;
    // bookPrefix3  : string;
    // ticketPrefix4: string;
    // bookPrefix4  : string;
    // ticketPrefix5: string;
    // bookPrefix5  : string;
    // ticketPrefix6: string;
    // bookPrefix6  : string;
}